module.exports = __webpack_public_path__ + "static/media/person.e3263d67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person.jpg
// module id = 31
// module chunks = 0